import { render } from "./lockPage.vue?vue&type=template&id=1ecaf7fc"
import script from "./lockPage.vue?vue&type=script&lang=js"
export * from "./lockPage.vue?vue&type=script&lang=js"

import "./lockPage.vue?vue&type=style&index=0&id=1ecaf7fc&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__